import React, { createContext, useContext, useState } from 'react';
import { getStoredCustomTagsInfo, setStoredCustomTagsInfo } from 'Utils/localStorage';
// Context
const CustomTagsContext = createContext(null);
const CustomTagsProvider = ({ children }) => {
    const [currentModelName, setCurrentModelName] = useState('');
    const [customTags, setCustomTags] = useState([]);
    const [isShowOnlyCustomSelected, setIsShowOnlyCustomSelected] = useState(false);
    // Handlers
    const handleSyncCustomTags = (modelName, tags) => {
        if (currentModelName === modelName) {
            return;
        }
        const storedCustomTagsInfo = getStoredCustomTagsInfo(modelName);
        const storedTags = storedCustomTagsInfo.reduce((acc, tagInfo) => {
            const foundTag = tags.find((tag) => tagInfo?.name === tag.name || tagInfo?.description === tag.description);
            return foundTag ? [...acc, foundTag] : acc;
        }, []);
        setCurrentModelName(modelName);
        setCustomTags(storedTags);
        setIsShowOnlyCustomSelected(false);
    };
    const handleSelectTag = (tag, checked) => {
        const isCustomTag = customTags.some((item) => item.name === tag.name);
        if (checked && isCustomTag)
            return;
        if (!checked && !isCustomTag)
            return;
        if (checked) {
            setCustomTags((prev) => {
                const nextCustomTags = [...prev, tag];
                setStoredCustomTagsInfo(currentModelName, nextCustomTags);
                return nextCustomTags;
            });
        }
        else {
            setCustomTags((prev) => {
                const nextCustomTags = prev.filter((item) => item.name !== tag.name);
                setStoredCustomTagsInfo(currentModelName, nextCustomTags);
                if (!nextCustomTags.length && isShowOnlyCustomSelected)
                    setIsShowOnlyCustomSelected(false);
                return nextCustomTags;
            });
        }
    };
    const handleResetCustomTags = () => {
        setCustomTags([]);
        setCurrentModelName('');
        setIsShowOnlyCustomSelected(false);
    };
    const handleClearSelection = () => {
        setCustomTags([]);
        setStoredCustomTagsInfo(currentModelName, []);
        setIsShowOnlyCustomSelected(false);
    };
    // Render
    return (React.createElement(CustomTagsContext.Provider, { value: {
            customTags: customTags,
            syncCustomTags: handleSyncCustomTags,
            onSelectTag: handleSelectTag,
            onClearSelection: handleClearSelection,
            resetCustomTags: handleResetCustomTags,
            isShowOnlyCustomSelected,
            onSetShowOnlyCustomSelected: setIsShowOnlyCustomSelected
        } }, children));
};
// Custom Hook
export const useCustomTags = () => useContext(CustomTagsContext);
export default CustomTagsProvider;
